import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { READ_ARTICLE } from '../data/navbar/menu';

const MediaCard = (props) => {
  const { t } = useTranslation();
  const [imageBroken, setImageBroken] = useState(false);
  const hasPhoto = props.image && props.image !== props.medialogo && !imageBroken;

  return (
    <div
      className={`news-tile${hasPhoto ? '' : ' news-tile-placeholder'}`}
      style={hasPhoto ? { backgroundImage: `url(${props.image})` } : undefined}
    >
      {hasPhoto && (
        <img
          className="news-tile-preload"
          src={props.image}
          alt=""
          onError={() => setImageBroken(true)}
        />
      )}
      <div className="news-tile-badge">{props.medianame}</div>
      <div className="news-tile-body">
        <div className="news-tile-title">{props.title}</div>
        <a
          className="news-tile-link"
          href={props.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t(READ_ARTICLE)} <FontAwesomeIcon icon={faArrowRight} />
        </a>
      </div>
    </div>
  );
}

export default MediaCard;
